module.exports = __webpack_public_path__ + "static/img/1-2.48ea21b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/1-2.png
// module id = shAd
// module chunks = 0